import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import { format } from "date-fns";

const SalesBeatPlanForm = (props) => {
  const frmRef = useRef({});

  const dateFormat = "dd/MM/yyyy";

  const [fromSelectedDate, setFromSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  var myDate = new Date();

  myDate.setDate(myDate.getDate() + 6);

  const [toSelectedDate, setToSelectedDate] = useState(
    myDate.toISOString().substr(0, 10)
  );

  const [SelectedDate, setSelectedDate] = useState(fromSelectedDate);

  const currentDate = new Date().toISOString().slice(0, 10);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerData, setFarmerData] = useState([]);
  const [customerListData, setCustomerListData] = useState([]);
  const [customerSelectListData, setcustomerSelectListData] = useState([]);
  const [plotsData, setPlotsData] = useState([]);
  const [datelist, setDatelist] = useState([]);

  const [beatplanDataList, setBeatplanDataList] = useState([]);

  const activateLasers = (e) => {
    setSelectedDate(e.target.innerText);
    // getEmployeeBeatPlanData(employeeId);
    getCustomerData(employeeId);
    getEmployeeBeatPlanData(employeeId, e.target.innerText);
  };

  const handledropdownlistChange = (e, index) => {
    //console.log("handledropdownlistChange", e.target.value);
    const value = e.target.value;
    customerSelectListData[index].taskName = e.target.value;
    var newstr = customerSelectListData;
    setcustomerSelectListData([...customerSelectListData]);

    // this.setcustomerSelectListData({ customerSelectListData: newstr });

    // return () => setcustomerSelectListData(customerSelectListData);
    // setcustomerSelectListData(customerSelectListData)
  };

  const handleFromDateChange = (e) => {
    setFromSelectedDate(e.target.value);

    var myFDate = new Date(e.target.value);
    var myTDate = new Date(toSelectedDate);

    setSelectedDate(format(myFDate, dateFormat));

    genrateDatelist(myFDate, myTDate);
  };
  const handleToDateChange = (e) => {
    setToSelectedDate(e.target.value);
    var myFDate = new Date(fromSelectedDate);
    var myTDate = new Date(e.target.value);

    genrateDatelist(myFDate, myTDate);
  };

  const genrateDatelist = (myFDate, myTDate) => {
    // //console.log( "genrateDatelist ","Start");
    // //console.log( "myFDate ",myFDate);
    // //console.log( "genrateDatelist ",myTDate);

    var Datelst = [];
    Datelst = Datelst.concat({
      Date: format(myFDate, dateFormat),
    });
    let result = moment(myTDate).diff(myFDate, "days");

    //console.log("result", result);
    var i = 1;
    do {
      var tempDate = new Date(myFDate);
      tempDate.setDate(tempDate.getDate() + i);

      Datelst = Datelst.concat({
        Date: format(tempDate, dateFormat),
      });

      i++;
    } while (i <= result);

    //while( format((myFDate.getDate() + i), 'dd/mm/yyyy') !=format(myTDate, 'dd/mm/yyyy'))

    setDatelist(Datelst);

    // //console.log( "Datelst ",Datelst);
    //  //console.log( format(myFDate, dateFormat) );
    //  //console.log( format(myTDate, dateFormat) );
  };

  const {
    
    sendRequest: getEmp,
  } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?useCase=Sales&orgId=${localStorage.getItem(
          "orgId"
        )}`,

        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");
        //console.log(emplist);

        setEmployeeData(emplist);
        var myFDate = new Date(fromSelectedDate);
        var myTDate = new Date(toSelectedDate);
        genrateDatelist(myFDate, myTDate);
        setSelectedDate(format(myFDate, dateFormat));
      }
    );
  }, [getEmp]);

  const {
  
    sendRequest: getplot,
  } = useHttp();

  useEffect(() => {
    const pdata = { createdBy: employeeId };
    getplot(
      {
        url: "/api/getPlots/",
        method: "POST",
        body: pdata,
      },
      (data) => {
        //console.log("emp", data.plotDetails);

        setPlotsData(data.plotDetails);
      }
    );
  }, [getplot]);

  const {
   
    sendRequest: getBeatPlanData,
  } = useHttp();

  const getEmployeeBeatPlanData = (empId, _date) => {
    const pdata = { fieldExecutiveId: empId, date: _date };
    // customerSelectListData=[];
    setBeatplanDataList([]);

    //console.log("fieldExecutiveId", empId);
    getBeatPlanData(
      {
        url: "/api/getSalesBeatPlanlist/",
        method: "POST",
        body: pdata,
      },
      (data) => {
        //console.log("BeatPlan", data.beatPlanDetails);
        var beatplalist = data.beatPlanDetails.filter(
          (item) => item.date == _date
        );
        setBeatplanDataList(beatplalist);
        setcustomerSelectListData(beatplalist);
        var i = 0;
        //console.log("beatplalist", beatplalist);
        do {
          var k = 0;
          do {
            if (customerListData[k].customerId == beatplalist[i].customerId) {
              customerListData[k].Iselected = true;
            }
            k++;
          } while (customerListData.length > k);
          i++;
        } while (beatplalist.length > i);

        //console.log("customerListData", customerListData);
        setCustomerListData([...customerListData]);
      }
    );
  };

  useEffect(() => {
    getEmployeeBeatPlanData();
  }, [getBeatPlanData]);

  const {
   
    sendRequest: getFarmers,
  } = useHttp();

  const getCustomerData = (empId) => {
    // customerSelectListData=[];
    setCustomerListData([]);
    setcustomerSelectListData([]);
    //console.log("empId", empId);

    const url = `/api/customer/?orgId=${localStorage.getItem(
      "orgId"
    )}&fieldExecutiveId=${empId}`;

    getFarmers(
      {
        url: url,
      },
      (data) => {
        //console.log("data", data);

        setCustomerListData(data);
      }
    );
  };

  useEffect(() => {
    getCustomerData();
  }, [getFarmers]);

  const handleSelect = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    var newselectList = customerSelectListData;

    if (isChecked) {
      const now = new Date();
      var fliterlist = customerListData.filter(
        (item) => item.customerId == value
      );
      const secondsSinceEpoch = Math.round(now.getTime() / 1000);

      // //console.log("fliterlist", fliterlist)
      newselectList = newselectList.concat({
        beatPlanId: secondsSinceEpoch,
        customerId: value,
        name: fliterlist && fliterlist[0].name,
        coordinates: '{"latitude":0.0,"longitude":0.0}', //fliterlist && fliterlist[0].coordinates,
        date: SelectedDate,
        taskId: 0,
        taskName: "",
        description: "",
        createdBy: parseInt(localStorage.getItem("id")),
        warehouseId: parseInt(localStorage.getItem("warehouseId")),
        orgId: localStorage.getItem("orgId"),
      });

      setcustomerSelectListData(newselectList);
    } else {
      newselectList = newselectList.filter((item) => item.customerId !== value);
      setcustomerSelectListData(newselectList);
    }
    //console.log("newselectList", newselectList);
  };

  const {
   
    sendRequest: posteatplan,
  } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    var newfinalList = [];
    var i = 0;

    //console.log("Submit Start");

    do {
      var newfinalList = newfinalList.concat({
        customerId: customerSelectListData[i].customerId,
        timeOfTask: "10:00 PM",
        fieldExecutiveId: employeeId,
        taskName: customerSelectListData[i].taskName,
        name: customerSelectListData[i].name,
        description: customerSelectListData[i].description,
        coordinates: customerSelectListData[i].coordinates, // "{\"latitude\":0.0,\"longitude\":0.0}",
        status: 1,
        date: customerSelectListData[i].date,

        beatPlanId: customerSelectListData[i].beatPlanId,
      });
      i++;
    } while (customerSelectListData.length > i);

    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      beatPlanDetails: newfinalList,
    };

    //console.log(data);

    posteatplan(
      {
        url: "/api/saleswebBeatPlan/",
        //    method: props.update ? "PUT" : "POST",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Beat plan detail added.`);
      }
    );
  };

  const bindBeatplanDate = (event, itemIndex) => {
    var Newlist = customerSelectListData;

    //console.log("itemIndex", itemIndex);
    // Newlist[itemIndex].date=event.target.value;

    Newlist[itemIndex].date = moment
      .utc(event.target.value)
      .toISOString()
      .substr(0, 10);

    setcustomerSelectListData(Newlist);
    //console.log("customerSelectListData", customerSelectListData);
  };

  const bindBeatplanTask = (event, itemIndex) => {
    // this.setState({
    //   customerSelectListData[itemIndex].taskNam=(event.target.value)})
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <div className="container-fluid">
            {/* SELECT2 EXAMPLE */}
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Add Beatplan Detail</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Sales Officer</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                          getCustomerData(e.target.value);
                          getEmployeeBeatPlanData(e.target.value);
                        }}
                      >
                        <option>--Select--</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.userId}
                              user-id={x.userId}
                              value={x.userId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>From Date </label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={fromSelectedDate}
                        onChange={handleFromDateChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>To Date</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={toSelectedDate}
                        onChange={handleToDateChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>
                </div>
                <div className="row">
                  <div className="col-md-3"> </div>
                  <div className="col-md-9">
                    <table className="table  table-responsive text-center table-sm">
                      <thead>
                        {datelist &&
                          datelist.map((itm, i) => {
                            return (
                              <th key={i}>
                                <button
                                  className="btn  btn-primary mx-2 my-2"
                                  type="submit"
                                  onClick={activateLasers}
                                >
                                  {itm.Date}
                                </button>
                              </th>
                            );
                          })}
                      </thead>
                    </table>
                  </div>
                </div>

                <form style={{ margin: "10px" }} onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-md-3">
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <th>Customer Name</th>

                        {customerListData &&
                          customerListData.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <div>
                                    <div className="flexRow">
                                      Customer Name: {itm.name}{" "}
                                      <input
                                        type="checkbox"
                                        name="languages"
                                        value={itm.customerId}
                                        checked={itm.Iselected}
                                        onChange={handleSelect}
                                      />
                                    </div>

                                    <div className="flexRow">
                                      Customer No: {itm.customerCode}{" "}
                                    </div>

                                    <div className="flexRow">
                                      Last Task : Customer registration
                                    </div>
                                    <div className="flexRow">
                                      Task Status: Completed/Pending
                                    </div>
                                  </div>

                                  <div
                                    className="flexRow"
                                    style={{
                                      background: "fray",
                                      height: "3px",
                                      padding: "10px",
                                    }}
                                  >
                                    &nbsp;{" "}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                    <div className="col-md-9">
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr className="tableheaderrowview">
                            <th>Customer Name</th>
                            <th>Task Date </th>
                            <th>Time </th>
                            <th>Task </th>
                            <th>Description </th>
                            <th>Status </th>

                            {/* <td>Delete</td> */}
                          </tr>
                        </thead>
                        <tbody>
                          {customerSelectListData &&
                            customerSelectListData.map((itm, i) => {
                              return (
                                <tr key={i}>
                                  <td>{itm.name}</td>
                                  <td>{itm.date}</td>

                                  <td>
                                    <input
                                      type={"time"}
                                      id={"packingTime"}
                                      required
                                      ref={(el) =>
                                        (frmRef.current["timeOfTask"] = el)
                                      }
                                      className="inputs"
                                      defaultValue={
                                        customerSelectListData[i].timeOfTask
                                      }
                                      onChange={(e) => {
                                        customerSelectListData[i].timeOfTask =
                                          e.target.value;
                                        setcustomerSelectListData(
                                          customerSelectListData
                                        );
                                      }}
                                    />
                                  </td>

                                  <td>
                                    {
                                      <select
                                        id="assign_task"
                                        className="inputs dropdowns"
                                        ref={(el) =>
                                          (frmRef.current["emp_id"] = el)
                                        }
                                        value={
                                          customerSelectListData[i].taskName
                                        }
                                        onChange={
                                          (e) => handledropdownlistChange(e, i)
                                          //customerSelectListData[i].taskName=(e.target.value)
                                        }

                                        //customerSelectListData[i].taskName=(e.target.value)
                                      >
                                        <option>--Select--</option>
                                        <option value="Prospecting">
                                          Prospecting
                                        </option>
                                        <option value="Follow-up Visit">
                                          Follow-up Visit
                                        </option>
                                        {/* <option>Farmer Registration</option> */}
                                        <option value="Farmer Meeting">
                                          {" "}
                                          Customer Meeting
                                        </option>
                                        <option value="Farmer Deal">
                                          Order Detail
                                        </option>

                                        <option value="Farmer Payment">
                                          Payment Receipt
                                        </option>

                                        <option value="Warehouse">
                                          Warehouse
                                        </option>
                                      </select>
                                    }
                                  </td>
                                  <td>
                                    {" "}
                                    <input
                                      type={"text"}
                                      id={"description"}
                                      required
                                      ref={(el) =>
                                        (frmRef.current["description"] = el)
                                      }
                                      className="inputs"
                                      defaultValue={
                                        customerSelectListData[i].description
                                      }
                                      onChange={(e) => {
                                        customerSelectListData[i].description =
                                          e.target.value;
                                        setcustomerSelectListData(
                                          customerSelectListData
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>
                                    {customerSelectListData[i].Status == 1
                                      ? "Completed"
                                      : "Pending"}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesBeatPlanForm;
